import { AspectRatio, Box, Button, Container, Stack, Typography, useTheme } from '@mui/joy';
import { LogoText } from '../../../components/module/Logo/Logo';
import { useMediaQuery } from '@mui/material';
import { FadeIn } from './FadeIn';

const ACCENT_COLOR_LIGHT = '#0c6bcb';
const ACCENT_COLOR_DARK = '#fff';

export function HeroSection() {
    const theme = useTheme();
    const isDark = theme.colorSchemes?.dark && theme.palette.mode === 'dark';
    const isMobile = useMediaQuery('(max-width:899px)');

    return (
        <Box
            id="hero"
            sx={{
                position: 'relative',
                backgroundImage: `
                    linear-gradient(180deg, transparent 0%, var(--joy-palette-background-body) 92%),
                    radial-gradient(ellipse at top left, rgba(89, 160, 244, .40), transparent 60%),
                    radial-gradient(ellipse at top right, rgba(137, 220, 255, .35), transparent 60%),
                    radial-gradient(ellipse at center, rgba(89, 160, 244, .18), transparent 70%)
                `,
                pb: 6,
            }}
        >
            <Container maxWidth="lg" sx={{ pt: { xs: 6, md: 10 }, position: 'relative' }}>
                <FadeIn duration={0.5}>
                    <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                        <LogoText
                            color={isDark ? ACCENT_COLOR_DARK : ACCENT_COLOR_LIGHT}
                            width={isMobile ? '150' : '200'}
                            height="auto"
                        />
                    </Stack>
                </FadeIn>

                <FadeIn delay={0.15} y={32}>
                    <Typography
                        level="h1"
                        sx={{
                            fontSize: { xs: '2.2rem', md: '4.5rem' },
                            fontWeight: 700,
                            mt: { xs: 6, md: 10 },
                            textAlign: 'center',
                            lineHeight: 1.1,
                        }}
                    >
                        Мессенджер и микроблог<br />в одном приложении
                    </Typography>
                </FadeIn>

                <FadeIn delay={0.3}>
                    <Typography
                        level="body-lg"
                        sx={{
                            textAlign: 'center',
                            mt: 3,
                            maxWidth: 560,
                            mx: 'auto',
                            color: 'text.secondary',
                            fontSize: { xs: '1rem', md: '1.25rem' },
                        }}
                    >
                        Переписывайтесь, звоните и делитесь мыслями в&nbsp;ленте.
                        Всё в&nbsp;одном пространстве.
                    </Typography>
                </FadeIn>

                <FadeIn delay={0.45}>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                        sx={{ mt: 5 }}
                    >
                        <Button
                            size="lg"
                            component="a"
                            href="https://aquarium.org.ru/auth"
                            sx={{
                                borderRadius: '999px',
                                px: 4,
                                py: 1.25,
                                fontSize: '1.05rem',
                                fontWeight: 700,
                                textDecoration: 'none !important'
                            }}
                        >
                            Зарегистрироваться
                        </Button>
                        <Button
                            size="lg"
                            component="a"
                            color="primary"
                            variant="soft"
                            href="#download"
                            sx={{
                                borderRadius: '999px',
                                px: 4,
                                py: 1.5,
                                fontSize: '1.05rem',
                                fontWeight: 700,
                                textDecoration: 'none !important',
                                backgroundColor: isDark
                                    ? 'var(--joy-palette-primary-800)'
                                    : 'var(--joy-palette-primary-200)',
                                color: isDark ? '#fff' : undefined,
                                '&:is(:hover, :active)': {
                                    backgroundColor: isDark
                                        ? 'var(--joy-palette-primary-700)'
                                        : 'var(--joy-palette-primary-300)',
                                },
                            }}
                        >
                            Скачать приложение
                        </Button>
                    </Stack>
                </FadeIn>

                <FadeIn delay={0.6} y={48}>
                    <Box sx={{ mt: { xs: 6, md: 10 } }}>
                        <AspectRatio ratio="16/9" sx={{ boxShadow: '0 12px 40px rgba(39, 110, 207, 0.10)', borderRadius: '24px', maxWidth: '960px', mx: 'auto' }}>
                            <img
                                src="/img/welcome/main-content.jpg"
                                alt="Главная страница мессенджера Аквариум"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                }}
                            />
                        </AspectRatio>
                    </Box>
                </FadeIn>
            </Container>
        </Box>
    );
}
